import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a href='https://github.com/jcavlovic' className='link footer__link'>
      &copy; 2024 Jordan Cavlovic
    </a>
  </footer>
)

export default Footer
